<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/inventorycount/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 10pt; text-alignment: left;">{{ getCompanySetting('CompanyAddress')}}</span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Count Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.countnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Count Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.countdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationname'] : '' }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Count By</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.length>0 ? users.find(user=>user._id == initvalue.userid)['username'] : '' }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%">
                    <tr>
                      <td><div align="center"><h3 class="ma-0"><b>{{ initvalue.counttype }}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <div style="margin-bottom: 10px;">&nbsp;</div>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="8%">Qty</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="8%">Pcs</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="12%">Quantity</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="7%">Cost</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px; text-align: right;" width="12%">Value</th>

                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ trans.itemname }}</td>
                          <td>{{ trans.itemqty }}</td>
                          <td>{{ trans.itempcs }}</td>
                          <td>{{ trans.itemquantity.toFixed(2) }}</td>
                          <td>{{ trans.itemcost }}</td>
                          <td style="text-align: right;">{{ (trans.itemcost * trans.itemquantity).toFixed(2) }}</td>
                        </tr>
                        <tr><td colspan="7" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="3" style="vertical-align: text-top; ">
                            <table width="100%">
                              <tr>
                                <td><p style="margin:0"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.countnote }}</span></td>
                              </tr>
                            </table>
                          </td>
                          <td colspan="4">
                            <table width="100%">
                              <tr>
                                <td><span style="font-size: 11pt; font-weight: bold">Total Count: </span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.counttotal }} </span></td>
                              </tr>
                              <tr>
                                <td><span style="font-size: 11pt; font-weight: bold">Total Value: </span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.transactions.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.itemquantity * tran.itemcost),0).toFixed(2) }}</span></td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
            companysettings: null,
            currencysettings: null,
            taxsettings: null,
          };
        },
        computed: {
          ...mapState('Location', ['locations']),
          ...mapState('SystemSetting', ['settings']),
          ...mapState('User', ['users']),
        },
        methods: {
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('SystemSetting', ['getSystemSettingsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getCompanySetting(name){
            if(!this.companysettings) return;
            let result = this.companysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);
          if(!this.initvalue._id) this.$router.push({ name: 'InventoryCountList' });
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.settings.length==0) await this.getSystemSettingsRequest();
          if(this.users.length==0) await this.getUsersRequest();
          this.companysettings = this.settings.find(setting=>setting.settingcode=='CompanySettings'); 
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
